import { Link } from "react-router-dom";
import { Icon } from "components";
import { PROJECT, JOB, RIGHT } from "icons";
import { useJob } from "@/modules/work/jobs/context";
import { ROUTE } from "@/lib/utils";

export const JobBreadcrumbs = () => {
  const { job } = useJob();
  if (!job) return null;

  return (
    <nav className="flex items-center text-sm ">
      <Link
        to={ROUTE.PROJECT(job?.project?.project_id)}
        className="flex items-center gap-2 px-2 py-1 rounded hover:bg-muted transition-colors"
      >
        <Icon icon={PROJECT} className="size-4 text-muted-foreground" />
        <span className="font-medium truncate max-w-[220px]">
          {job?.project?.name}
        </span>
      </Link>

      <Icon icon={RIGHT} className="text-muted-foreground" />
      <div className="flex items-center gap-2 px-2 py-1">
        <Icon icon={JOB} className="size-4 text-muted-foreground" />
        <span className="truncate max-w-[260px] font-medium">
          {job?.name ?? "Job"}
        </span>
      </div>
    </nav>
  );
};
